"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var __1 = require("../../../");
var component_1 = require("../../../component");
var element_1 = require("../../../element");
var base_1 = require("./base");
var LineRenderer = /** @class */ (function (_super) {
    __extends(LineRenderer, _super);
    function LineRenderer() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.defaultScaleDataKey = "line";
        return _this;
    }
    LineRenderer.prototype.renderSection = function (section) {
        var _this = this;
        _super.prototype.renderSection.call(this, section);
        this._group = section.appendT(component_1.Component).options({
            _datum: function (d, i, g) {
                var data = _this.transformData(d).data;
                var xScale = section.parent.circos.xScaleForChr(d._key);
                // data
                var points = data.map(function (p) {
                    var _a = __1.tool.polar2cart(xScale(p.pos), _this._yScale[d._key](p.value)), x = _a[0], y = _a[1];
                    return { x: x, y: y, data: p.data };
                });
                var path = points.map(function (_a) {
                    var x = _a.x, y = _a.y;
                    return "L" + x + "," + y;
                }).join(" ");
                path = "M" + path.slice(1);
                return { path: path, points: points };
            },
        });
        this._lines = this._group.appendT(element_1.Path).options({
            d: function (d) { return d.path; },
            fill: "none",
            stroke: "#444",
            _tooltip: function () { return "" + section.parent.getOption("_label"); },
            _$mouseEnter: function () {
                this.style.opacity = "0.5";
            },
            _$mouseLeave: function () {
                this.style.opacity = "1";
            },
        });
        this._points = this._group.appendGroupT(element_1.Circle).options({
            _data: function (d) { return d.points; },
            _x: function (d) { return d.x; },
            _y: function (d) { return d.y; },
            _r: 1,
            fill: "#444",
            _tooltip: function (d) { return "" + _this.dataTransformer(d.data).value; },
            _$mouseEnter: function () {
                this.style.opacity = "0.5";
            },
            _$mouseLeave: function () {
                this.style.opacity = "1";
            },
        });
        this.assignGOptions({ dot: "_points", line: "_lines" });
    };
    return LineRenderer;
}(base_1.Renderer));
exports.LineRenderer = LineRenderer;
//# sourceMappingURL=line.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/bvd3/dist/component/circos/layers/line.js
// module id = 1183
// module chunks = 0 1